module.exports = __webpack_public_path__ + "img/Store-W.024973f.svg";